import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const Booting = () => (
  <div className="flex min-h-dvh items-center justify-center bg-background">
    <Loader2 className="h-6 w-6 animate-spin text-primary" />
  </div>
);

export const RequireRole = ({ role, children }) => {
  const { user, booting } = useAuth();
  const location = useLocation();
  if (booting) return <Booting />;
  if (!user) {
    return <Navigate to={role === "admin" ? "/admin/login" : "/login"} replace state={{ from: location }} />;
  }
  if (user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin/dashboard" : "/dashboard"} replace />;
  }
  return children;
};

export const RedirectIfAuthed = ({ children }) => {
  const { user, booting } = useAuth();
  if (booting) return <Booting />;
  if (user) return <Navigate to={user.role === "admin" ? "/admin/dashboard" : "/dashboard"} replace />;
  return children;
};
